module.exports = __webpack_public_path__ + "static/media/for-startups-insight@3x.da907671.jpg";